import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { FormHelperText, Heading, Radio } from 'base-ui'

import { BrandsProviderType } from '../../../marketplacePartnerRegisterPageMakeFormState'
import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'

export const MarketplacePartnerRegisterPageFormBrandsProviderTypeSelection: FC =
  () => {
    const { formState } = useMarketplacePartnerRegisterPageContext()
    formState.use()

    const selected = formState.model.brandsProviderType
    const fieldName = 'brandsProviderType'

    return (
      <span className="flex flex-col gap-4">
        <Heading level={2} size="l">
          <FormattedMessage id="marketplacePartnerRegisterPage.brands.provide.description" />
        </Heading>
        <fieldset className="mt-4 flex flex-row gap-5">
          <label className="flex items-center gap-2">
            <Radio
              checked={selected === BrandsProviderType.DROPDOWN}
              data-qa-id="sellerForm-radio-brandsProviderType-dropdown"
              name={fieldName}
              onChange={(): void => {
                formState.setValue(
                  BrandsProviderType.DROPDOWN,
                  formState.model,
                  fieldName,
                )
                formState.setValue('', formState.model, 'brandsTextArea')
              }}
            />
            <span>
              <FormattedMessage id="marketplacePartnerRegisterPage.brands.provide.dropdown" />
            </span>
          </label>
          <label className="flex items-center gap-2">
            <Radio
              checked={selected === BrandsProviderType.LIST}
              data-qa-id="sellerForm-radio-brandsProviderType-list"
              name={fieldName}
              onChange={(): void => {
                formState.setValue(
                  BrandsProviderType.LIST,
                  formState.model,
                  fieldName,
                )
                formState.setValue([], formState.model, 'brandsDropDown')
              }}
            />
            <span>
              <FormattedMessage id="marketplacePartnerRegisterPage.brands.provide.list" />
            </span>
          </label>
        </fieldset>
        {formState.model.validator.getFirstErrorFor(fieldName) && (
          <FormHelperText
            data-qa-id={`global-MessageForm-${fieldName}-error-msg`}
            error
          >
            {formState.model.validator.getFirstErrorFor(fieldName)}
          </FormHelperText>
        )}
      </span>
    )
  }
